"use client";

import cn from "classnames";

import { CompareRowLabel } from "@/components/compareRowLabel/compareRowLabel.component";

import {
  COMPARE_COMPETITOR_TABLE_APPEARANCES,
  type CompareCompetitorTableAppearance,
} from "@/sanity/defaults/compareCompetitorTable.defaults";

import {
  columnHighlightClass,
  rowDividerClass,
} from "./compareCompetitorTable.tableUtils";
import type {
  SanityCompetitorCompareColumn,
  SanityCompetitorCompareRow,
} from "./compareCompetitorTable.type";
import { CompareCompetitorTableValue } from "./compareCompetitorTableValue.component";

export const CompareCompetitorTableRow = ({
  row,
  columns,
  rowIndex,
  rowCount,
  highlightIndex,
  appearance,
  hasCtaRow,
}: CompareCompetitorTableRowProps) => {
  const isFirstRow = rowIndex === 0;
  const isLastRow = rowIndex === rowCount - 1;
  const cells = row.cells ?? [];

  return (
    <tr data-testid={`compare-competitor-table-row-${row.id}`}>
      <th
        scope="row"
        className={cn(
          "text-greyscale-body p-4 py-5 text-left align-middle sm:py-6",
          rowDividerClass(isFirstRow),
        )}>
        <CompareRowLabel
          label={row.label}
          info={row.info}
          variant={
            appearance === COMPARE_COMPETITOR_TABLE_APPEARANCES.adt
              ? "body2"
              : "body1"
          }
        />
      </th>
      {columns.map((column, columnIndex) => (
        <td
          key={`${row.id}-${column.id}`}
          className={cn(
            "px-2 py-5 text-center align-middle sm:py-6",
            rowDividerClass(isFirstRow),
            columnHighlightClass(
              columnIndex,
              highlightIndex,
              isLastRow && !hasCtaRow ? "last" : "body",
              appearance,
            ),
          )}>
          <CompareCompetitorTableValue
            cell={cells[columnIndex]}
            columnIndex={columnIndex}
            highlightIndex={highlightIndex}
            appearance={appearance}
          />
        </td>
      ))}
    </tr>
  );
};

type CompareCompetitorTableRowProps = {
  row: SanityCompetitorCompareRow;
  columns: SanityCompetitorCompareColumn[];
  rowIndex: number;
  rowCount: number;
  highlightIndex: number;
  appearance: CompareCompetitorTableAppearance;
  hasCtaRow: boolean;
};
